import { BASE_URL } from '@/api/index';
import axios, { AxiosRequestConfig } from 'axios';
import {
  AppleBusinessConnectBrand,
  AppleBusinessConnectCompany,
  AppleBusinessConnectionConnect,
  AppleBusinessConnectLocation,
} from 'ignite360-core';

export class AppleBusinessConnectApi {
  static async loadCompany(botId: string): Promise<AppleBusinessConnectCompany> {
    const config: AxiosRequestConfig = {
      method: 'GET',
      url: `${BASE_URL}/public/apple-business-connect/companies?bot_id=${botId}`,
    };

    const res = await axios.request(config);

    if (res.status === 200) {
      return res.data as AppleBusinessConnectCompany;
    }

    throw new Error('Something went wrong while loading companies!');
  }

  static async loadBrands(botId: string, companyId: string): Promise<AppleBusinessConnectBrand[]> {
    const config: AxiosRequestConfig = {
      method: 'GET',
      url: `${BASE_URL}/public/apple-business-connect/brands?bot_id=${botId}&company_id=${companyId}`,
    };

    const res = await axios.request(config);

    if (res.status === 200) {
      return res.data as AppleBusinessConnectBrand[];
    }

    throw new Error('Something went wrong while loading brands!');
  }

  static async loadLocations(
    botId: string,
    companyId: string,
    brandId: string,
  ): Promise<AppleBusinessConnectLocation[]> {
    const config: AxiosRequestConfig = {
      method: 'GET',
      url: `${BASE_URL}/public/apple-business-connect/locations?bot_id=${botId}&company_id=${companyId}&brand_id=${brandId}`,
    };

    const res = await axios.request(config);

    if (res.status === 200) {
      return res.data as AppleBusinessConnectLocation[];
    }

    throw new Error('Something went wrong while loading locations!');
  }

  static async connectBotWithAppleBusinessConnectLocation(
    botId: string,
    data: AppleBusinessConnectionConnect,
  ): Promise<void> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: `${BASE_URL}/public/bots/${botId}/apple-business-connect/subscribe`,
      data,
    };

    const res = await axios.request(config);

    if (res.status === 200) {
      return;
    }

    throw new Error(
      res.data.error ||
        'Something went wrong while trying to connect your Apple Business Connect location.',
    );
  }

  static async disconnectBotFromAppleBusinessConnectLocation(botId: string): Promise<void> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: `${BASE_URL}/public/bots/${botId}/apple-business-connect/unsubscribe`,
    };

    const res = await axios.request(config);

    if (res.status === 204) {
      return;
    }

    throw new Error(
      res.data.error ||
        'Something went wrong while trying to disconnect your Apple Business Connect location.',
    );
  }

  static async publishTestPost(botId: string): Promise<void> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: `${BASE_URL}/public/bots/${botId}/apple-business-connect/publish-listing`,
    };

    const res = await axios.request(config);

    if (res.status === 204) {
      return;
    }

    throw new Error(res.data.error || 'Something went wrong while trying to publish a test post.');
  }
}
